module.exports = __webpack_public_path__ + "static/media/check.2dfc9294.svg";